module.exports = __webpack_public_path__ + "static/media/news.b8df9735.gif";